import {useMutation} from "react-query";
import {ResidentService} from "../../../services/ResidentServices";
import Alert from "react-s-alert";

export const useShowResident = ({refetch}: {refetch: () => void}) =>
  useMutation(
    (resident_id: string) =>
      ResidentService.patchResident(resident_id, {is_archived: false}),
    {
      onError: () => {
        Alert.error("Failed to restore resident.");
      },
      onSuccess: () => {
        refetch();
      },
    },
  );
